<dynamic-form
  *ngIf="formGroup && isOkForLoad && columns && columns.length > 0"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [defaultHeight]="25"
  [isShowModal]="false"
  [submitButtonDisabled]="submitButtonDisabled()"
  [erroremessage]="erroremessage"
  [hasDefault]="false"
  (valueChangeByApiName)="onChange($event)"
  (valueChangeWithName)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="formGroup && isOkForLoad">
    <ssg-tabset (tabChange)="selectTab($event)">
      <ssg-tab tabTitle="اقلام">
        <div class="detail" *ngIf="currentVoucherKind && SellVoucherDetailColumns && SellVoucherDetailColumns.length > 0">
          <sellvoucher-detail
            #detail
            (rowChanges)="onValueChanges($event)"
            (valueChanges)="onValueChanges($event)"
            [isPriceable]="Priceable"
            [isAdd]="!isNoValidForEdit()"
            [detailLedgerLevel]="detailLedgerLevel"
            [isEdit]="!isNoValidForEdit()"
            [isDelete]="!isNoValidForEdit()"
            [AccountRegistered]="model.StatusKindCode === 3"
            [HasJournalVoucher]="HasJournalVoucher"
            [hasDiscount]="hasDiscount"
            [hasReferenceRequired]="hasReferenceRequired"
            [hasReference]="hasReference"
            [filterEntity]="filterEntity"
            [ReferenceVoucherKindId]="ReferenceVoucherKindId"
            [CurrentVoucherKind]="currentVoucherKind"
            [columns]="SellVoucherDetailColumns"
            [RowNumberName]="'RowNumber'"
            [(dataList)]="model.SellVoucherDetailList">
          </sellvoucher-detail>
        </div>
        <div class="col">
          <div class="InvBalanceColumns" [style.width.%]="InvBalanceColumnswidth">
            <kgrid
              *ngIf="ShowStockAmount && StockInfoColumns && StockInfoColumns.length > 0"
              [label]="label"
              [name]="apiName"
              [columns]="StockInfoColumns"
              [(dataList)]="filterdDataList"
              [isAdd]="false"
              [isEdit]="false"
              [isDelete]="false"
              [groupable]="false"
              [filtering]="false"
              [noToolBar]="true">
            </kgrid>
          </div>
          <div>
            <form-control-model
              [defaultHeight]="25"
              [columns]="DiscountColumns"
              [group]="formGroup"
              (valueChangeWithName)="onvalueChangeWithName($event)"
              [model]="model">
            </form-control-model>
          </div>
          <div>
            <form-control-model [defaultHeight]="25" [columns]="footerColumns" [group]="formGroup" [model]="model"> </form-control-model>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab tabTitle="اطلاعات مشتری">
        <div class="col">
          <div style="margin-top: 25px">
            <form-control-model
              *ngIf="CustomerColumns && CustomerColumns.length > 0"
              [defaultHeight]="25"
              [columns]="CustomerColumns"
              [group]="formGroup"
              [model]="model?.Customer">
            </form-control-model>
          </div>
          <div style="width: 85%; height: 100%">
            <span>سررسید بدهیها</span>
            <kgrid
              *ngIf="CustomerVoucherColumns && CustomerVoucherColumns.length > 0"
              [label]="label"
              [name]="apiName"
              [columns]="CustomerVoucherColumns"
              [dataList]="CustomerVouchers"
              [isModal]="false"
              [isMulti]="false"
              pathPreFix="SELL"
              [isAdd]="false"
              [isEdit]="false"
              [isDelete]="false">
            </kgrid>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab tabTitle="حساب تفصیلی">
        <div>
          <form-control-model
            *ngIf="activeTabTitle === 'حساب تفصیلی' && DetailLedgerColumnDetailLedger && DetailLedgerColumnDetailLedger.length > 0"
            [defaultHeight]="25"
            [columns]="DetailLedgerColumnDetailLedger"
            [group]="formGroup"
            [model]="model"
            (valueChangeByApiName)="onValueChangeByApiName($event)">
          </form-control-model>
        </div>
        <div>
          <form-control-model
            *ngIf="activeTabTitle === 'حساب تفصیلی' && DetailLedgerColumnSellDetailLedger && DetailLedgerColumnSellDetailLedger.length > 0"
            [defaultHeight]="25"
            [columns]="DetailLedgerColumnSellDetailLedger"
            [group]="formGroup"
            [model]="model"
            (valueChangeByApiName)="onValueChangeByApiName($event)">
          </form-control-model>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
  <ng-container class="footer">
    <ssg-button class="btnstyle" (click)="ngOnInit()" data-tooltip="top" tooltip="بازخوانی اطلاعات" icon="icon-refresh-o"> </ssg-button>
    <ssg-button
      icon="icon-list-f"
      buttontype="button"
      (click)="loadVoucherList()"
      class="login-btn"
      tooltip="لیست اسناد"
      [disabled]="false"
      appearance="mini-btn"
      class="btnfooter">
    </ssg-button>
    <ssg-button
      icon="icon-file-document-multiple-outline"
      buttontype="button"
      (click)="newVoucher()"
      class="btnfooter"
      tooltip="سند جدید"
      appearance="flat">
    </ssg-button>

    <ssg-button
      icon="icon-auto_delete-o"
      buttontype="button"
      (click)="deleteVoucher()"
      class="btnfooter"
      tooltip="حذف سند"
      [disabled]="model?.StatusKindCode >= 2 || isNewRow"
      appearance="flat">
    </ssg-button>
    <ssg-button
      *hasPermission="['SellCustomer:SellVoucherHeader/CreateAccVoucher', 'Same']"
      icon="icon-create_new_folder-o"
      (click)="accountAccVoucher(true)"
      buttontype="button"
      class="btnfooter"
      tooltip="صدور سند حسابداری"
      [hidden]="!HasJournalVoucher"
      [disabled]="!HasJournalVoucher || isNewRow || model.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
    <ssg-button
      *hasPermission="['SellCustomer:SellVoucherHeader/DeleteAccVoucher', 'Same']"
      icon="icon-delete-sweep-outline"
      (click)="accountAccVoucher(false)"
      buttontype="button"
      class="btnfooter"
      tooltip="حذف سند حسابداری"
      [hidden]="!HasJournalVoucher"
      [disabled]="!HasJournalVoucher || isNewRow || !model.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
    <ssg-button
      *hasPermission="['SellCustomer:SellVoucherHeader/ViewAccVoucher', 'Same']"
      icon="icon-table_view-f"
      (click)="viewAccVoucher()"
      buttontype="button"
      class="btnfooter"
      tooltip="نمایش سند حسابداری"
      [hidden]="!HasJournalVoucher"
      [disabled]="!HasJournalVoucher || !model.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
    <ssg-button
      icon="icon-folder-open-outline"
      buttontype="button"
      (click)="voucherConfirm()"
      class="btnfooter2"
      [tooltip]="confirmLabel"
      [disabled]="model?.StatusKindCode > 2 || isNewRow"
      size="medium"
      appearance="flat">
    </ssg-button>

    <ssg-menu
      *ngIf="ReferenceToVoucherKinds && ReferenceToVoucherKinds.length >= 0 && !isNewRow"
      icon="icon-content_copy-o"
      class="btnstyle"
      tooltip="معطوف">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let voucherKind of ReferenceToVoucherKinds" class="reportbtn">
            <button class="btn" (click)="changeReferenceToVoucherKind(voucherKind.Id)">{{ voucherKind.Title }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
    <!-- <i *ngIf="ReferenceToVoucherKinds && ReferenceToVoucherKinds.length >= 0  && !isNewRow">
                <select [(ngModel)]="CurrentReferenceToVoucherKindId" (change)="changeReferenceToVoucherKind(CurrentReferenceToVoucherKindId)" (click)="changeReferenceToVoucherKind(CurrentReferenceToVoucherKindId)">
                  <option *ngFor="let voucherKind of ReferenceToVoucherKinds" [ngValue]="voucherKind.Id" >{{voucherKind.Title}}</option>
                </select>
              </i> -->
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
